<h1 class="text--dark-gray">Produkthantering</h1>
<div #inventoryNav></div>
@if (inventoryVisible) {
    <h2>Lager</h2>
    <woo-tabs [noSelectionTemplate]="emptyTpl1">
        <woo-tab label="AG maxuttag" name="ag_maxuttag" [component]="ManageAgWithdrawalLimits"></woo-tab>
        <woo-tab label="Completion Rate" name="completion_rate" [component]="ManageCompletionRatesEstimates"></woo-tab>
        <woo-tab label="Frekvenstak" name="frekvenstak" [component]="ManageFrequencyLimits"></woo-tab>
        <woo-tab label="Kategorier" name="kategorier" [component]="ManageCategories"></woo-tab>
        <woo-tab label="Pausreklam" name="pausreklam" [component]="ManagePauseAdEstimates" ></woo-tab>
        <woo-tab label="Placering" name="placering" [component]="ManageProductFormatShares"></woo-tab>
        <woo-tab label="Spelbolag" name="spelbolag" [component]="ManageGamblingEstimates"></woo-tab>
        <woo-tab label="Bruttokontakter" name="bruttokontakter" [component]="ManageGrossRatingFactor"></woo-tab>

        <ng-template #emptyTpl1>
            <div class="tabbable__body rounded-top-right no-margin">
              <h3>Här kan du administrera lager</h3>
            </div>
        </ng-template>
    </woo-tabs>
}

<h2>Styrning</h2>
<woo-tabs [noSelectionTemplate]="emptyTpl2">
    <woo-tab label="Apparater" name="apparater" [component]="ManageDeviceGroups"></woo-tab>
    <woo-tab label="Avancerade målgrupper" name="avancerade_malgrupper" [component]="ManageAdvancedTargetGroups"></woo-tab>
    <woo-tab label="Beteendesegment" name="beteendesegment" [component]="ManageBehaviors"></woo-tab>
    <woo-tab label="Dayparts" name="dayparts" [component]="ManageDayparts"></woo-tab>
    <woo-tab label="Målgrupper" name="malgrupper" [component]="ManageTargetGroups" ></woo-tab>
    <woo-tab label="Programformat" name="programformat" [component]="ManageProgramFormats"></woo-tab>
    <woo-tab label="Regioner" name="regioner" [component]="ManageRegions"></woo-tab>

    <ng-template #emptyTpl2>
        <div class="tabbable__body rounded-top-right no-margin">
          <h3>Här kan du administrera Styrning</h3>
        </div>
    </ng-template>
</woo-tabs>

<h2>Övrigt</h2>
<woo-tabs [noSelectionTemplate]="emptyTpl3">
    <woo-tab label="Enheter" name="enheter" [component]="ManageDevices"></woo-tab>
    <woo-tab label="Prislistor" name="prislistor" [component]="ManagePriceLists"></woo-tab>
    <woo-tab label="Universum" name="universum" [component]="ManageUniverse"></woo-tab>
    <woo-tab label="Standard frekvenstak" name="kategorier3" [component]="ManageDefaultFrequencyLimits"></woo-tab>

    <ng-template #emptyTpl3>
        <div class="tabbable__body rounded-top-right no-margin">
          <h3>Här kan du administrera Övrigt</h3>
        </div>
    </ng-template>
</woo-tabs>